<template>
  <v-card style="display: flex; align-items: center;">
    <v-btn small icon light @click="closeSubscribeDialog" style="text-align: right; position: absolute; top: 40px; right: 40px; padding: 0; margin: 0">
      <v-icon>close</v-icon>
    </v-btn>
    <v-card-text style="width: 80%; height: 100%">
      <ManageUsers v-on:close="closeSubscribeDialog" v-on:update="handleUpdate" v-on:subscribe="handleSubscription" v-bind:options="{project: options.project, button: buttonType, buttonText: buttonText, buttonLoading: subscribeButtonLoading, subscriptionSuccess: subscriptionSuccess, dialogType: options.dialogType}"></ManageUsers>
    </v-card-text>
  </v-card>
</template>

<style>
  .doneBtn{
    width: 160px;
    margin-left: 0;
    height: 45px;
  }
  .doneBtn:hover:before{
    background-color: transparent;
  }
</style>
<script>
import { mapGetters, mapMutations } from 'vuex'
import axios from 'axios'
import ManageUsers from './appElements/ManageUsers.vue'

export default {
  props: {
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      subscriptionSuccess: false,
      subscribeButtonLoading: false,
      subscriptionUsers: [],
      invitationUsers: [],
      projects: [],
      usersAdded: [],
      usersRemoved: [],
      usersInvited: []
    }
  },
  components: {
    ManageUsers
  },
  mounted () {
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'currentUser']),
    ...mapGetters({
      getUserOrganization: 'getUserOrganization',
      getRoleByName: 'getRoleByName',
      getPlanById: 'getPlanById'
    }),
    buttonText () {
      if (this.getUserOrganization.organizationUsers.find(item => { return item.userId === this.currentUser.id }).roleId === this.getRoleByName('VIEWER_ROLE').id) {
        return 'Suggest Project'
      }
      return 'Subscribe'
    },
    buttonType () {
      return this.options.dialogType === 'users' ? 'manage' : 'subscribe'
    }
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    getOrganizationData () {
      axios.all([this.$store.dispatch('getOrganizationsWithAllById', {id: this.getUserOrganization.id})]).then(axios.spread((response) => {
        if (response.data.status === 'SUCCESS') {
          this.$store.commit('setUserOrganization', response.data.payload)
        } else {
          this.notify({message: 'Something went wrong.', show: true})
        }
      })).catch((err) => {
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    handleSubscription (subscriptionObject) {
      this.subscribeButtonLoading = true
      this.subscriptionUsers = JSON.parse(JSON.stringify(subscriptionObject.selectedUsers))
      this.subscriptionUsers.push(this.currentUser)
      this.invitationUsers = subscriptionObject.invitedUsers
      this.projects = subscriptionObject.selectedProjects
      if (this.getUserOrganization.organizationUsers.find(item => { return item.userId === this.currentUser.id }).roleId === this.getRoleByName('VIEWER_ROLE').id) {
        this.subscribe(null)
      } else {
        this.stripeSubscribe()
      }
    },
    getUserEmail (id) {
      return this.getUserOrganization.users.find(item => { return item.id === id }).email
    },
    handleUpdate (subscriptionObject) {
      this.subscribeButtonLoading = true
      this.subscriptionUsers = subscriptionObject.selectedUsers
      this.invitationUsers = subscriptionObject.invitedUsers
      this.projects = [this.options.project.id]
      this.usersAdded = []
      this.usersRemoved = []
      this.usersInvited = []
      var self = this
      this.subscriptionUsers.forEach(function (user) {
        if (self.getUserOrganization.organizationUserProjects.find(item => { return item.userId === user.id && item.projectId === self.options.project.id })) {} else {
          self.usersAdded.push(user)
        }
      })
      var subscriptions = this.getUserOrganization.organizationUserProjects.filter(item => { return item.projectId === this.options.project.id })
      subscriptions.forEach(function (sub) {
        if (sub.userId !== self.currentUser.id && self.subscriptionUsers.filter(item => { return item.id === sub.userId }).length === 0 && self.invitationUsers.filter(item => { return item.email === self.getUserEmail(sub.userId) }).length === 0) {
          self.usersRemoved.push(self.getUserOrganization.users.find(item => { return item.id === sub.userId }))
        }
      })
      this.invitationUsers.forEach(function (invitee) {
        if (self.getUserOrganization.users.filter(item => { return item.email === invitee.email }).length === 0) {
          self.usersInvited.push(invitee)
        }
      })
      if (this.usersAdded.length > 0) {
        this.addUsers()
      } else if (this.usersRemoved.length > 0) {
        this.removeUsers()
      } else if (this.usersInvited.length > 0) {
        this.invitationUsers = this.usersInvited
        this.sendUserInvitations()
      } else {
        this.closeSubscribeDialog()
      }
    },
    closeSubscribeDialog () {
      this.projects = []
      this.subscriptionUsers = []
      this.invitationUsers = []
      this.subscriptionSuccess = false
      this.subscribeButtonLoading = false
      this.$emit('close-subscribe-dialog')
    },
    async stripeSubscribe () {
      let plan = this.getPlanById(this.options.planId)
      if (plan.tier !== 0 && this.currentUser.defaultRoleId !== this.getRoleByName('MASTER_ROLE').id) {
        let organizationUuid = this.getUserOrganization.uuid
        let retrieveCustomerResponse = await this.$store.dispatch('stripe/retrieveCustomer', {organizationUuid: organizationUuid})
        if (retrieveCustomerResponse.data.status === 'SUCCESS') {
          if (retrieveCustomerResponse.data.payload === undefined || retrieveCustomerResponse.data.payload.sources === null) {
            this.subscribeButtonLoading = false
            this.notify({message: 'No payment information provided.', show: true})
            return null
          }
        }
        let interval = ''
        let intervalCount = 1
        if (plan.period === 'MONTHLY') {
          interval = 'month'
        } else if (plan.period === 'QUARTERLY') {
          interval = 'month'
          intervalCount = 3
        } else if (plan.period === 'YEARLY') {
          interval = 'year'
        }
        let createProductandPlanResponse = await this.$store.dispatch('stripe/createProductandPlan', {projectUuid: this.options.project.uuid, planUuid: plan.uuid, name: this.options.project.name, description: this.options.project.description, period: plan.period, monthlyFee: plan.fixedFee, interval: interval, intervalCount: intervalCount, trialPeriodDays: 0, type: 'SUBSCRIPTION'})
        if (createProductandPlanResponse.productResponse.data.status === 'SUCCESS' && createProductandPlanResponse.planResponse.data.status === 'SUCCESS') {
          let stripeSubId = this.getUserOrganization.stripeSubConfig && this.getUserOrganization.stripeSubConfig !== null && plan.period in this.getUserOrganization.stripeSubConfig ? this.getUserOrganization.stripeSubConfig[plan.period] : null
          if (!stripeSubId) {
            axios.all([this.$store.dispatch('stripe/createSubscription', {period: plan.period, organizationUuid: organizationUuid, projectUuid: this.options.project.uuid, planUuid: plan.uuid, trialPeriodDays: 0, type: 'SUBSCRIPTION', status: 'Active'})]).then(axios.spread((subscriptionResponse) => {
              if (subscriptionResponse.data.status === 'SUCCESS') {
                if (this.options.viewerRequestAccepted) {
                  this.updateProject(subscriptionResponse.data.payload.items.data[0].id)
                } else {
                  this.subscribe(subscriptionResponse.data.payload.items.data[0].id)
                }
              } else {
                this.subscribeButtonLoading = false
                this.notify({message: 'Something went wrong while connecting to the server.', show: true})
              }
            })).catch((err) => {
              this.subscribeButtonLoading = false
              this.notify({message: 'Something went wrong while connecting to the server.', show: true})
              console.log(err)
            })
          } else {
            axios.all([this.$store.dispatch('stripe/createSubscriptionItem', {period: plan.period, subscriptionId: stripeSubId, projectUuid: this.options.project.uuid, planUuid: plan.uuid, trialPeriodDays: 0, type: 'SUBSCRIPTION', status: 'Active'})]).then(axios.spread((subscriptionItemResponse) => {
              if (subscriptionItemResponse.data.status === 'SUCCESS') {
                if (this.options.viewerRequestAccepted) {
                  this.updateProject(subscriptionItemResponse.data.payload.id)
                } else {
                  this.subscribe(subscriptionItemResponse.data.payload.id)
                }
              } else {
                this.subscribeButtonLoading = false
                this.notify({message: 'Something went wrong while connecting to the server.', show: true})
              }
            })).catch((err) => {
              this.subscribeButtonLoading = false
              this.notify({message: 'Something went wrong while connecting to the server.', show: true})
              console.log(err)
            })
          }
        } else {
          this.subscribeButtonLoading = false
          this.notify({message: 'Something went wrong while connecting to the server.', show: true})
          return null
        }
      } else {
        if (this.options.viewerRequestAccepted) {
          this.updateProject(null)
        } else {
          this.subscribe(null)
        }
      }
    },
    updateProject (stripeItemId) {
      this.subscribeButtonLoading = true
      var organizationProject = {organizationId: this.getUserOrganization.id, projectId: this.options.project.id, planId: this.options.planId, type: 'SUBSCRIPTION', status: 'Active'}
      if (stripeItemId) {
        organizationProject.stripeItemId = stripeItemId
      }
      var newSubscriptionUsers = []
      for (var u = 0; u < this.subscriptionUsers.length; u++) {
        if (this.getUserOrganization.organizationUserProjects.find(item => { return item.userId === this.subscriptionUsers[u].id && item.projectId === this.options.project.id })) {
          newSubscriptionUsers.push(this.subscriptionUsers[u])
        }
      }
      axios.all([this.$store.dispatch('updateOrganizationProject', organizationProject)]).then(axios.spread((orgProjectResponse) => {
        if (orgProjectResponse.data.status === 'SUCCESS') {
          for (var u = 0; u < newSubscriptionUsers.length; u++) {
            var organizationUserProject = {
              organizationId: orgProjectResponse.data.payload.organizationId,
              projectId: orgProjectResponse.data.payload.projectId,
              userId: newSubscriptionUsers[u].id,
              roleId: this.getUserOrganization.organizationUsers.find(item => { return item.userId === newSubscriptionUsers[u].id }).roleId,
              status: status
            }
            axios.all([this.$store.dispatch('addOrganizationUserProject', organizationUserProject)]).then(axios.spread((orgUserProjectResponse) => {
              if (orgUserProjectResponse.data.status === 'SUCCESS') {
                if (u >= newSubscriptionUsers.length - 1) {
                  axios.all([this.$store.dispatch('getUserByUuid', {uuid: this.currentUser.uuid})]).then(axios.spread((userResponse) => {
                    if (userResponse.data.status === 'SUCCESS') {
                      this.$store.commit('auth/setUser', userResponse.data.payload)
                      if (this.invitationUsers.length > 0 && this.invitationUsers[0].email !== '') {
                        this.sendUserInvitations()
                      } else {
                        this.subscribeButtonLoading = false
                        this.subscriptionSuccess = true
                        this.getOrganizationData()
                      }
                    } else {
                      this.subscribeButtonLoading = false
                      this.notify({message: 'Something went wrong.', show: true})
                    }
                  })).catch((err) => {
                    this.subscribeButtonLoading = false
                    this.notify({message: 'Something went wrong while connecting to the server.', show: true})
                    console.log(err)
                  })
                }
              } else {
                this.subscribeButtonLoading = false
                this.notify({message: 'Something went wrong.', show: true})
              }
            })).catch((err) => {
              this.subscribeButtonLoading = false
              this.notify({message: 'Something went wrong while connecting to the server.', show: true})
              console.log(err)
            })
          }
        } else {
          this.subscribeButtonLoading = false
          this.notify({message: 'Something went wrong.', show: true})
        }
      })).catch((err) => {
        this.subscribeButtonLoading = false
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    subscribe (stripeItemId) {
      var status = 'Active'
      var organizationProject = {organizationId: this.getUserOrganization.id, projectId: this.options.project.id, planId: this.options.planId, type: 'SUBSCRIPTION', status: 'Active'}
      if (stripeItemId) {
        organizationProject.stripeItemId = stripeItemId
      } else {
        var adminIds = this.getUserOrganization.organizationUsers.filter(item => { return item.roleId === this.getRoleByName('ADMIN_ROLE') })
        this.subscriptionUsers = []
        for (var ui = 0; ui < adminIds.length; ui++) {
          this.subscriptionUsers.push(this.getUserOrganization.users.find(item => { return item.id === adminIds[ui] }))
        }
        this.subscriptionUsers.push(this.currentUser)
        status = 'Pending Organization Approval'
        organizationProject.status = 'Pending Organization Approval'
      }
      axios.all([this.$store.dispatch('addOrganizationProject', organizationProject)]).then(axios.spread((orgProjectResponse) => {
        if (orgProjectResponse.data.status === 'SUCCESS') {
          for (var u = 0; u < this.subscriptionUsers.length; u++) {
            var organizationUserProject = {
              organizationId: orgProjectResponse.data.payload.organizationId,
              projectId: orgProjectResponse.data.payload.projectId,
              userId: this.subscriptionUsers[u].id,
              roleId: this.getUserOrganization.organizationUsers.find(item => { return item.userId === this.subscriptionUsers[u].id }).roleId,
              status: status
            }
            axios.all([this.$store.dispatch('addOrganizationUserProject', organizationUserProject)]).then(axios.spread((orgUserProjectResponse) => {
              if (orgUserProjectResponse.data.status === 'SUCCESS') {
                if (u >= this.subscriptionUsers.length - 1) {
                  axios.all([this.$store.dispatch('getUserByUuid', {uuid: this.currentUser.uuid})]).then(axios.spread((userResponse) => {
                    if (userResponse.data.status === 'SUCCESS') {
                      this.$store.commit('auth/setUser', userResponse.data.payload)
                      if (this.invitationUsers.length > 0 && this.invitationUsers[0].email !== '') {
                        this.sendUserInvitations()
                      } else {
                        this.subscribeButtonLoading = false
                        this.subscriptionSuccess = true
                        this.getOrganizationData()
                      }
                    } else {
                      this.subscribeButtonLoading = false
                      this.notify({message: 'Something went wrong.', show: true})
                    }
                  })).catch((err) => {
                    this.subscribeButtonLoading = false
                    this.notify({message: 'Something went wrong while connecting to the server.', show: true})
                    console.log(err)
                  })
                }
              } else {
                this.subscribeButtonLoading = false
                this.notify({message: 'Something went wrong.', show: true})
              }
            })).catch((err) => {
              this.subscribeButtonLoading = false
              this.notify({message: 'Something went wrong while connecting to the server.', show: true})
              console.log(err)
            })
          }
        } else {
          this.subscribeButtonLoading = false
          this.$emit('close-subscribe-dialog')
          this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        }
      })).catch((err) => {
        this.subscribeButtonLoading = false
        this.$emit('close-subscribe-dialog')
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    sendUserInvitations () {
      var count = 0
      for (var u = 0; u < this.invitationUsers.length; u++) {
        if (this.invitationUsers[u].email && this.invitationUsers[u].email !== '') {
          var role = this.invitationUsers[u].isAdmin ? this.getRoleByName('ADMIN_ROLE').id : this.getRoleByName('VIEWER_ROLE').id
          var invitationObject = {
            userId: this.currentUser.id,
            organizationId: this.getUserOrganization.id,
            organizationRoleId: role,
            projectRoleId: role,
            emails: [this.invitationUsers[u].email],
            projectIds: this.projects
          }
          axios.all([this.$store.dispatch('inviteUsers', invitationObject)]).then(axios.spread((response) => {
            if (response.data.status === 'SUCCESS') {
              count++
              if (count > this.invitationUsers.length - 1) {
                this.getOrganizationData()
                this.subscribeButtonLoading = false
                this.subscriptionSuccess = true
              }
            } else {
              this.notify({message: 'Something went wrong while inviting new users.', show: true})
              this.subscribeButtonLoading = false
            }
          })).catch((err) => {
            this.notify({message: 'Something went wrong while connecting to the server.', show: true})
            this.subscribeButtonLoading = false
            console.log(err)
          })
        } else {
          count++
        }
      }
    },
    addUsers () {
      for (var u = 0; u < this.usersAdded.length; u++) {
        var organizationUserProject = {
          organizationId: this.getUserOrganization.id,
          projectId: this.options.project.id,
          userId: this.usersAdded[u].id,
          roleId: this.getUserOrganization.organizationUsers.find(item => { return item.userId === this.usersAdded[u].id }).roleId,
          status: status
        }
        axios.all([this.$store.dispatch('addOrganizationUserProject', organizationUserProject)]).then(axios.spread((orgUserProjectResponse) => {
          if (orgUserProjectResponse.data.status === 'SUCCESS') {
            if (u >= this.usersAdded.length - 1) {
              if (this.usersRemoved.length > 0) {
                this.removeUsers()
              } else if (this.usersInvited.length > 0) {
                this.invitationUsers = this.usersInvited
                this.sendUserInvitations()
              } else {
                this.subscribeButtonLoading = false
                this.subscriptionSuccess = true
                this.getOrganizationData()
              }
            }
          } else {
            this.subscribeButtonLoading = false
            this.notify({message: 'Something went wrong.', show: true})
          }
        })).catch((err) => {
          this.subscribeButtonLoading = false
          this.notify({message: 'Something went wrong while connecting to the server.', show: true})
          console.log(err)
        })
      }
    },
    removeUsers () {
      for (var u = 0; u < this.usersRemoved.length; u++) {
        var organizationUserProject = {
          organizationId: this.getUserOrganization.id,
          projectId: this.options.project.id,
          userId: this.usersRemoved[u].id
        }
        axios.all([this.$store.dispatch('deleteOrganizationsUsersProjects', organizationUserProject)]).then(axios.spread((orgUserProjectResponse) => {
          if (orgUserProjectResponse.data.status === 'SUCCESS') {
            if (u >= this.usersRemoved.length - 1) {
              if (this.usersInvited.length > 0) {
                this.invitationUsers = this.usersInvited
                this.sendUserInvitations()
              } else {
                this.subscribeButtonLoading = false
                this.subscriptionSuccess = true
                this.getOrganizationData()
              }
            }
          } else {
            this.subscribeButtonLoading = false
            this.notify({message: 'Something went wrong.', show: true})
          }
        })).catch((err) => {
          this.subscribeButtonLoading = false
          this.notify({message: 'Something went wrong while connecting to the server.', show: true})
          console.log(err)
        })
      }
    },
    goToProject () {
      var route = 'https://app.dataslicer.io/#/home?projectUuid=' + this.options.project.uuid
      window.open(route, '_blank')
      this.$emit('close-subscribe-dialog')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Subscribe.vue